import {
  callCallback,
  createContentRequest,
  stopLoadingShowError,
} from "../utils";
import * as tvx from "../lib/tvx-plugin-module.min";
import {
  MSXMenuRoot,
  MSXContentRoot,
  Tools,
  MSXContentItem,
  MSXContentPage,
} from "../lib/tvx-plugin-module.min";
import {
  res_backgroundColor,
  res_backgroundJPG,
  res_home,
  res_login_background,
  res_movies,
} from "../static-res";
import { getCollectionFictions } from "../api/worker";
import { apiCollectionFiction } from "../api/api-models";

function createFictionItem(fiction: apiCollectionFiction): MSXContentItem {
  const object =
    fiction.fiction.kind == "movie"
      ? fiction.fiction.movie
      : fiction.fiction.serial;
  return {
    type: "separate",
    image: object.portraitImage,
    title: object.title.toUpperCase(),
    action:
      "content:" +
      createContentRequest(`fiction:${fiction.fiction.kind}:${object.imdbid}`),
  };
}

export function createCollectionRoot(
  collectionSlug: string,
  callback: (data: any) => void
): void {
  tvx.InteractionPlugin.stopLoading();
  getCollectionFictions(collectionSlug).then((result) => {
    console.log(result);

    const collectionRoot: MSXContentRoot = {
      cache: true,
      restore: true,
      reuse: true,
      type: "list",
      headline: result.collection.name.toUpperCase(),
      flag: "collection",
      background: res_backgroundJPG,
      transparent: true,
      important: true,
      template: {
        layout: "0,0,2,4",
      },
      items: [],
    };
    result.fictions
      .sort((a, b) => a.position - b.position)
      .forEach((fiction) => {
        collectionRoot.items.push(createFictionItem(fiction));
      });
    callCallback(collectionRoot, callback);
  });
}
